import React from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Link } from "@bca/ui-library";

import { StoreType } from "../../redux/StoreType";
import { handlePrintExportFile } from "../../helpers/handlePrintExportFile";
import useDeviceType from "../../hooks/useDeviceType.hook";
import useTouchEvents from "../../hooks/useTouchEvents.hook";
import { GET_APP_STATE } from "../../redux/slices/appSlice";

const PrintLink: React.FunctionComponent<{
  name: string;
  url: string;
  dataEl: string;
  isToUseAuthZero?: boolean;
  accessToken?: string;
}> = ({ name, url, dataEl, isToUseAuthZero = false, accessToken }) => {
  const dispatch = useDispatch();
  const {
    app: { isLoadingFile },
  }: StoreType = useSelector(GET_APP_STATE, shallowEqual);
  const { isDesktopDevice } = useDeviceType();

  const handleOnClick = () =>
    !isLoadingFile && handlePrintExportFile(dispatch, url, isToUseAuthZero, accessToken);

  const { handleTouchStart, handleTouchMove, handleTouchEnd } =
    useTouchEvents(handleOnClick);

  return (
    <Link
      css={`
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 14px;
        margin-left: 36px;
        ${isLoadingFile &&
        `
          opacity: 0.3;
          pointer-events: none;
        `}
      `}
      color="#070b16"
      target="_blank"
      data-en="click"
      data-ec="document"
      data-ea="print"
      data-et="pdf"
      data-el={dataEl}
      onClick={isDesktopDevice ? handleOnClick : undefined}
      onTouchStart={!isDesktopDevice ? handleTouchStart : undefined}
      onTouchMove={!isDesktopDevice ? handleTouchMove : undefined}
      onTouchEnd={!isDesktopDevice ? handleTouchEnd : undefined}
    >
      {name}
    </Link>
  );
};

export default PrintLink;
